import { CfCard08Props } from "../types";
import { convertCfBackgroundColorProps } from "utilities/cfPropTypes/cfBackground";
import { convertCfImageProps } from "components/Image/CfImage";
import Card08 from "..";
import React from "react";
import parse from "html-react-parser";

export const convertCfCard08Props = ({
  abstract,
  borderTop,
  image,
  title,
  children,
}: CfCard08Props) => {
  return {
    abstract: abstract?.abstract ? parse(abstract?.abstract) : undefined,
    title: title ? parse(title) : undefined,
    imageProps: image ? convertCfImageProps(image[0]) : undefined,
    borderTop: convertCfBackgroundColorProps(borderTop),
    children,
  };
};

const CfCard08 = (props: CfCard08Props) => (
  <Card08 {...convertCfCard08Props(props)} />
);

export default CfCard08;
